import * as Http from './Axios'

export default Http;